export enum CorporationQueryKeys {
  GetCorporationById = 'GetCorporationById',
  GetCorporationQuota = 'GetCorporationQuota',
}
